export enum PaymentMethodEnum {
    CARD = 'CARD',
    APPLE_PAY = 'APPLE_PAY',
    BANK_TRANSFER = 'BANK_TRANSFER'
}